



















import { Vue, Component, Prop, Watch } from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { BillingPeriodWithEmployersResponse, BillingPeriodEmployer } from "@/shared/types";
import * as _ from "lodash";

@Component({
  components: {
    Button,
    GenericLoadingSpinner
  }
})

export default class EmployerMonthlyReport extends Vue {
  @Prop() employerId: number;
  @Prop() selectableBillingPeriods: BillingPeriodWithEmployersResponse[];
  @Prop() periodsLoaded: boolean;
  @Prop() loadBillingPeriodsByEmployer: (args: { employerId: number }) => Promise<void>;
  @Prop() resetBillingPeriodsState: () => Promise<void>;
  @Prop() setPeriod: (arg: {billingPeriodId: number, reportName: string}) => Promise<void>;
  @Prop() downloadReportForEmployer: ( args: {
    periodId: number,
    periodName: string,
    employerId: number
  }) => Promise<void>;

  selectedPeriod: BillingPeriodWithEmployersResponse = null;
  selectedEmployer: BillingPeriodEmployer = null;

  get periodName (): null | string { return _.get(this.selectedPeriod, "periodName", null); }
  get periodValue (): null | number { return _.get(this.selectedPeriod, "periodId", null); }

  @Watch("selectedPeriod")
  onPeriodSelected () {
    this.setPeriod({
      billingPeriodId: this.periodValue,
      reportName: this.periodName
    });
  }

  get hasSpecifiedReport () { return Boolean(this.selectedPeriod); }
  get hasMonthlyBillingPeriods () { return this.selectableBillingPeriods && this.selectableBillingPeriods.length > 0; }

  mounted () {
    this.resetBillingPeriodsState();
    if (this.employerId) {
      this.loadBillingPeriodsByEmployer({ employerId: this.employerId });
    }
  }

  downloadCsv () {
    if (!this.hasSpecifiedReport) {
      return;
    }

    this.downloadReportForEmployer({
      periodId: this.selectedPeriod.periodId,
      periodName: this.selectedPeriod.periodName,
      employerId: this.employerId
    });
  }
}


